import { OtpChannelsViewModel } from '@apis/model/mfa/OtpChannelsViewModel';
import { OtpChannelResponse } from '@ul/api';

export const toOtpChannelsViewModel = (otpChannelResponse: OtpChannelResponse): OtpChannelsViewModel => {
    const { success, responseCode, status, message, channels } = otpChannelResponse;
    return {
        success,
        responseCode,
        status,
        message,
        channels,
    };
};
